import { toast } from 'react-toastify';

import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { HttpException } from '../../../exceptions/index';
import { useAppMutation, useLocale } from '../../../hooks/index';
import ApiService from '../../../services/api-service.util';

export type RequestMoreEnvelopesVariables = {
  companyId: string;
  customMessage?: string;
};

export type UseRequestMoreEnvelopesParams = {
  onSuccess?: () => void;
};

export const useRequestMoreEnvelopes = ({ onSuccess }: UseRequestMoreEnvelopesParams = {}) => {
  const { messagesLocale } = useLocale();

  const { isPending, mutate: requestMoreEnvelopes } = useAppMutation<
    { sent: true },
    HttpException,
    RequestMoreEnvelopesVariables
  >([QueryKey.REQUEST_MORE_ENVELOPES], {
    mutationFn: ({ companyId, customMessage }) =>
      ApiService.post<{ sent: true }>(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'request-more-envelopes'] },
        {
          body: {
            ...(customMessage?.trim() ? { customMessage: customMessage.trim() } : {}),
          },
        },
      ),
    onSuccess: () => {
      toast.success(messagesLocale['GET_MORE_ENVELOPES_REQUEST_SENT']);
      onSuccess?.();
    },
  });

  return { isPending, requestMoreEnvelopes };
};
